import type { CityConfig } from "../city-template/types";

export const biddefordConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — York County Clerk", href: "https://www.yorkcountymaine.gov/", description: "York County Clerk — marriage license issuance" },
    { label: "Divorce Records — York County Clerk", href: "https://www.yorkcountymaine.gov/", description: "York County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Biddeford",
  state: "Maine",
  stateAbbr: "ME",
  slug: "biddeford",
  route: "/cities/biddeford",
  title: "Emergency Passport Biddeford, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Biddeford, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Biddeford, Saco, Kennebunk, and Arundel travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Biddeford, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Biddeford and York County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Biddeford%20Maine%20coastal%20city%20with%20Saco%20River%2C%20historic%20textile%20mill%20buildings%20converted%20to%20modern%20use%2C%20charming%20downtown%20Main%20Street%2C%20warm%20New%20England%20autumn%20afternoon%20light%2C%20professional%20cityscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20scenic%20river%20and%20mill%20district%20view&width=1800&height=700&seq=biddeford-hero-001&orientation=landscape",
  heroImageAlt: "Biddeford Maine coastal city with Saco River and historic textile mill buildings",
  geoPosition: "43.4926;-70.4534",
  geoPlacename: "Biddeford, Maine",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 85 miles (1.5 hours) from Biddeford, ME",
  },
  nearbyCitiesZips: [
    { name: "Downtown Biddeford", zips: "04005" },
    { name: "Saco", zips: "04072" },
    { name: "Kennebunk", zips: "04043" },
    { name: "Kennebunkport", zips: "04046" },
    { name: "Arundel", zips: "04046" },
    { name: "Old Orchard Beach", zips: "04064" },
    { name: "Scarborough", zips: "04074" },
    { name: "Buxton", zips: "04093" },
    { name: "Lyman", zips: "04002" },
    { name: "Dayton", zips: "04005" },
    { name: "Hollis", zips: "04042" },
    { name: "Waterboro", zips: "04087" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Biddeford departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Portland", route: "/cities/portland-me" },
    { name: "Emergency passport help in Saco", route: "/cities/saco" },
    { name: "Urgent passport services in South Portland", route: "/cities/south-portland" },
    { name: "Same-day passport help in Kennebunk", route: "/cities/kennebunk" },
    { name: "Expedited passport services in Augusta", route: "/cities/augusta-me" },
    { name: "Passport courier services in Bangor", route: "/bangor" },
    { name: "Rush passport help in Westbrook", route: "/cities/westbrook" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Biddeford, Maine remotely via secure courier. We do not have a walk-in office in Biddeford — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Biddeford travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving all of southern York County",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Biddeford and the surrounding York County area. From downtown Biddeford's historic mill district to the coastal communities of Saco and Old Orchard Beach — we help Biddeford travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Biddeford neighborhoods and nearby cities including Saco, Kennebunk, Kennebunkport, Old Orchard Beach, Arundel, and Scarborough. If you are in southern York County, we have you covered.",
  howItWorksIntro: "Most Biddeford travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "With Biddeford being a gateway city for coastal Maine travelers, passport delays can disrupt beach trips and international getaways. Here are the most common mistakes we see.",
  testimonialsIntro: "Biddeford travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Biddeford? Here are the most common ones we hear from Maine travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Biddeford international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Amanda K.",
      location: "Biddeford, ME",
      rating: 5,
      text: "My flight to Cancún was in 4 days and my passport had expired. Fast Passport Center got me a new one in under 48 hours. Shipped from Biddeford — seamless from start to finish.",
      service: "Emergency Passport",
    },
    {
      name: "David R.",
      location: "Saco, ME",
      rating: 5,
      text: "Needed to renew my passport for a cruise departing from Boston. They reviewed all my documents and I had my passport in 5 business days. Fantastic service.",
      service: "Passport Renewal",
    },
    {
      name: "Michelle T.",
      location: "Kennebunk, ME",
      rating: 5,
      text: "Lost my passport two weeks before my honeymoon to the Dominican Republic. Fast Passport Center handled everything — DS-64 and replacement — in just 2 days. Lifesaver.",
      service: "Lost Passport",
    },
    {
      name: "Brian O.",
      location: "Old Orchard Beach, ME",
      rating: 5,
      text: "I travel frequently for work and need a dependable passport service. Fast Passport Center has never let me down. Professional, fast, and always on time.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "biddeford-1",
      name: "Biddeford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "70 Main St",
      city: "Biddeford",
      state: "ME",
      zip: "04005",
      phone: "(207) 282-6325",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Biddeford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "biddeford-2",
      name: "Saco Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "30 Main St",
      city: "Saco",
      state: "ME",
      zip: "04072",
      phone: "(207) 282-6091",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2 miles from downtown Biddeford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Saco residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "biddeford-3",
      name: "Kennebunk Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5 York St",
      city: "Kennebunk",
      state: "ME",
      zip: "04043",
      phone: "(207) 985-4792",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles from downtown Biddeford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good option for Kennebunk and Kennebunkport residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "biddeford-4",
      name: "Old Orchard Beach Town Office",
      type: "Town Office Passport Acceptance",
      address: "1 Portland Ave",
      city: "Old Orchard Beach",
      state: "ME",
      zip: "04064",
      phone: "(207) 934-5714",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "6 miles from downtown Biddeford",
      website: "https://www.oldorchardbeachmaine.com/",
      websiteLabel: "Old Orchard Beach Town Office",
      notes: "Accepts walk-ins but appointments preferred. Photo services not available on-site.",
      icon: "ri-government-line",
    },
    {
      id: "biddeford-5",
      name: "Arundel Town Office",
      type: "Town Office Passport Acceptance",
      address: "468 Limerick Rd",
      city: "Arundel",
      state: "ME",
      zip: "04046",
      phone: "(207) 985-4775",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "7 miles from downtown Biddeford",
      website: "https://www.arundelmaine.org/",
      websiteLabel: "Arundel Town Office",
      notes: "Small town office with limited hours. Call ahead to schedule passport acceptance.",
      icon: "ri-government-line",
    },
    {
      id: "biddeford-6",
      name: "Scarborough Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "37 Pleasant Hill Rd",
      city: "Scarborough",
      state: "ME",
      zip: "04074",
      phone: "(207) 883-5124",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "14 miles from downtown Biddeford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Scarborough and southern Portland area residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Maine photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Biddeford acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Biddeford applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Biddeford families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Biddeford travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Biddeford." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Biddeford address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Biddeford, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Biddeford in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Biddeford travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Biddeford, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Biddeford residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Biddeford, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Biddeford with no office visit required. We serve all Biddeford neighborhoods and the surrounding York County area. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "What is the fastest way to get an urgent passport in Biddeford, Maine?",
      a: "The fastest way to get an urgent passport in Biddeford is through Fast Passport Center's emergency courier service. Our registered couriers deliver your documents directly to State Department processing facilities, achieving 24–48 hour turnaround. This is significantly faster than standard mail processing (8–11 weeks) or even government expedited mail (2–3 weeks).",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Biddeford?",
      a: "Popular options include the Biddeford Post Office (04005), Saco Post Office (04072), Kennebunk Post Office (04043), and Old Orchard Beach Town Office (04064). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "What if I live in Saco, Kennebunk, or Old Orchard Beach?",
      a: "We serve all of southern York County including Saco, Kennebunk, Kennebunkport, Old Orchard Beach, Arundel, and Scarborough. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Biddeford?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Biddeford?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and UPS Store locations in Biddeford and Saco offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Biddeford?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Biddeford?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Biddeford families through the entire process and help schedule acceptance clerk appointments.",
    },
    {
      q: "How far is Biddeford from the Boston Passport Agency?",
      a: "Biddeford is approximately 85 miles from the Boston Passport Agency — about a 1.5-hour drive. With Fast Passport Center, you avoid that trip entirely. We courier your documents directly to State Department facilities, saving you time and the stress of driving to Boston.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Biddeford", address: "55 Alfred St, Biddeford, ME 04005", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Saco", address: "534 Main St, Saco, ME 04072", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Biddeford", address: "340 Alfred St, Biddeford, ME 04005", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Biddeford", address: "452 Alfred St, Biddeford, ME 04005", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Old Orchard Beach", address: "1 Saco Ave, Old Orchard Beach, ME 04064", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "Walgreens — Kennebunk", address: "25 York St, Kennebunk, ME 04043", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Scarborough", address: "425 Payne Rd, Scarborough, ME 04074", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Sanford", address: "29 Main St, Sanford, ME 04073", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    {
      name: "BMV — Biddeford",
      address: "75 Industrial Park Rd, Saco, ME 04072",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "BMV — Kennebunk",
      address: "6 Storer St, Kennebunk, ME 04043",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "BMV — Old Orchard Beach",
      address: "1 Portland Ave, Old Orchard Beach, ME 04064",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "BMV — Scarborough",
      address: "500 Route 1, Scarborough, ME 04074",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center. Online appointment system available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "20 miles from Biddeford (30 minutes)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with direct flights to Canada, Florida, and major U.S. hubs. The primary international departure point for Biddeford-area travelers.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: true,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "85 miles from Biddeford (1.5 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many Biddeford travelers connect through Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
    {
      code: "MHT",
      name: "Manchester-Boston Regional Airport",
      distance: "80 miles from Biddeford (1.5 hours)",
      address: "1 Airport Rd, Manchester, NH 03103",
      note: "Budget-friendly alternative with select domestic routes. Useful for some southern Maine travelers.",
      flightUrl: "https://www.manchesterairport.com/",
      flightLabel: "Manchester Airport",
      featured: false,
    },
  ],
};